import { render, staticRenderFns } from "./ShowAddress.vue?vue&type=template&id=0b07a281&scoped=true&"
import script from "./ShowAddress.vue?vue&type=script&lang=js&"
export * from "./ShowAddress.vue?vue&type=script&lang=js&"
import style0 from "./ShowAddress.vue?vue&type=style&index=0&id=0b07a281&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07a281",
  null
  
)

export default component.exports